import { _ as r } from "../internals/export.js";
import { f as s } from "../internals/fails.js";
import { i as a } from "../internals/is-object.js";
import { c as t } from "../internals/classof-raw.js";
import { a as e } from "../internals/array-buffer-non-extensible.js";
var i = Object.isSealed;
r({
  target: "Object",
  stat: !0,
  forced: e || s(function () {
    i(1);
  })
}, {
  isSealed: function isSealed(r) {
    return !a(r) || !!e && "ArrayBuffer" == t(r) || !!i && i(r);
  }
});